export async function handleResponse(response: Response): Promise<any> {
    if (response.status === 402) {
      window.location.href = '/subscription'; // Redirect to the subscription page
      return;
    }
  
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText); // Throw an error for other HTTP status codes
    }
  
    try {
      return await response.json();
    } catch (error) {
      throw new Error("Failed to parse response JSON");
    }
  }
  